import { EnumBase } from 'hay-core-react';
class TemplateTestequalidadestreamEnum extends EnumBase {
  constructor() {
    super(
      [
        'main.monitoramentotemplate.testequalidadestream.youtube',
        'main.monitoramentotemplate.testequalidadestream.desativado',
      ],
      'main.monitoramentotemplate.testequalidadestream.desativado'
    );
  }
}

export default new TemplateTestequalidadestreamEnum();
